// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2dFm4","inner":"Footer_inner__1IJvJ"};